var bremenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zur Freien Hansestadt Bremen?',
    image: '341',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '302',
    question: 'Welches ist ein Stadtteil von Bremen?',
    answers: [
      {
        content: 'Altona',
        key: 0,
      },
      {
        content: 'Hemelingen',
        key: 1,
      },
      {
        content: 'Pankow',
        key: 0,
      },
      {
        content: 'Babelsberg',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird das Landesparlament in Bremen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
      {
        content: '5',
        key: 0,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Bremen bei den Wahlen zur Bürgerschaft (Landtag) wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Bremen?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'rot-weiß',
        key: 1,
      },
      {
        content: 'schwarz-gold',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Bremen über politische Themen informieren?',
    answers: [
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '307',
    question: 'Was ist ein deutscher Stadtstaat?',
    answers: [
      {
        content: 'Bremen',
        key: 1,
      },
      {
        content: 'München',
        key: 0,
      },
      {
        content: 'Frankfurt',
        key: 0,
      },
      {
        content: 'Erfurt',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Bremen?',
    image: '348',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin des Stadtstaates Bremen?',
    answers: [
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 0,
      },
      {
        content: 'Erster Bürgermeister / Erste Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Präsident / Präsidentin des Senats',
        key: 1,
      },
      {
        content: 'Regierender Bürgermeister / Regierende Bürgermeisterin',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
  {
    id: '310',
    question: 'Welchen Senator / welche Senatorin hat Bremen nicht?',
    answers: [
      {
        content: 'Senator / Senatorin für Außenbeziehungen',
        key: 1,
      },
      {
        content: 'Finanzsenator / Finanzsenatorin',
        key: 0,
      },
      {
        content: 'Justizsenator / Justizsenatorin',
        key: 0,
      },
      {
        content: 'Innensenator / Innensenatorin',
        key: 0,
      },
    ],
    category: 'Bremen',
  },
]

export default bremenQuestions
